import { useCohortContext } from '@eigtech/ui-shared-api'
import { getLog } from '@eigtech/ui-shared-logging'
import { AddNoteRequest, useCreateEntityNote, useNotesContext } from '@eigtech/ui-shared-notes'
import { toast } from '@eigtech/ui/components/sonner'
import { useCallback } from 'react'
import { NoteFieldsType } from '../CreateNote/NoteFieldsSchema'
import { makeAddNotePayload } from '../utils/makeAddNotePayload'

const log = getLog()

export function useCreateOptionalEntityNote() {
  const { cohort } = useCohortContext()
  const { dataSource } = useNotesContext()
  const { mutateAsync, ...mutation } = useCreateEntityNote()

  const createNote = useCallback(
    async (
      data: NoteFieldsType & { includeNote: boolean } & Pick<AddNoteRequest, 'entityCorn'>
    ) => {
      if (data.includeNote) {
        const notePayload = makeAddNotePayload({ ...data, cohort, source: dataSource })

        try {
          await mutateAsync(notePayload)
        } catch (e) {
          log.error('could not create note', e)
          toast.warning('Failed to create note.')
        }
      }
    },
    [cohort, dataSource, mutateAsync, toast]
  )

  return {
    createNote,
    ...mutation,
  }
}
